import { render } from "./LogoFooter.vue?vue&type=template&id=785d1d11"
import script from "./LogoFooter.vue?vue&type=script&lang=js"
export * from "./LogoFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__